<div class="advanceOption">
  <input
    type="checkbox"
    id="settings"
    (click)="toggleSettings()"
    [checked]="advanceOption"
  />
  <label for="settings" class="checkbox-label-settings"
    >Advanced settings</label
  >
</div>
<div class="container">
  <div class="advanced-settings" *ngIf="advanceOption; else regularContent">
    <evrideo-graphics-rectangle-f
      *ngIf="rectangleFVM"
      [vm]="rectangleFVM"
    ></evrideo-graphics-rectangle-f>
    <evrideo-layer-input
      [(zIndex)]="zLayer"
      (zIndexChange)="zLayerChangedEventHandler($event)"
    ></evrideo-layer-input>
  </div>
  <ng-template #regularContent>
    <div *ngIf="!!positionField">
      <span>POSITION ON SCREEN:</span>
      <icn-graphics-position
        [positionField]="positionField"
      ></icn-graphics-position>
    </div>
    <div class="scale-and-layer">
      <div *ngIf="!!scaleField" class="scale-field">
        <span>SCALE:</span>
        <icn-graphics-scale [scaleField]="scaleField"></icn-graphics-scale>
      </div>
      <evrideo-layer-input
        [(zIndex)]="zLayer"
        (zIndexChange)="zLayerChangedEventHandler($event)"
      ></evrideo-layer-input>
    </div>
  </ng-template>
</div>
